import {
  Component,
  OnInit,
  Input, 
  Output, 
  EventEmitter,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';

import { ActionSheetController } from '@ionic/angular';
import { LogEntryPhoto } from '../../../../../models/logs/photos/LogEntryPhoto.interface';
import { AlertController } from '@ionic/angular';
import { IonInput } from '@ionic/angular';
import { Data, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ReceivingLogStateService } from '../../../../../domain/receiving-log/receiving-log-state.service';
import { AssetsDataService } from '../../../../../service/assets-data.service';
import { ContactsService } from '../../../../../service/contact.service';
import { ToastService } from '../../../../../service/toast.service';
import { EmailService } from '../../../../../service/email.service';
import { ScreenSizeService } from '../../../../../service/screen-size.service';
import { PrintService } from '../../../../../service/print.service';
import { EntraService } from '../../../../../service/entra.service';
import { PhotoService } from '../../../../../service/photo.service';
import { copyPhotosToClipboard } from '../../../../../helpers/copy-photos';
import { DataLoading } from '../../../../../models/DataLoading.interface';
@Component({
  selector: 'app-photo-manager',
  templateUrl: './photo-manager.component.html',
  styleUrls: ['./photo-manager.component.css'],
})
export class PhotoManagerComponent implements OnInit, OnDestroy {
  @Output() photoInclusionChanged = new EventEmitter<boolean>();
  @Input() photosDisabled: boolean = false;

  private photosSubscription!: Subscription;
  private dataLoadingSubscription!: Subscription;

  public photos: LogEntryPhoto[] = [];
  public isMobile: boolean = false;
  public minPhotos: number = 3;
  public selectedPhotoIndex: number = 0;
  public isPhotoModalOpen: boolean = false;
  public showLastLogsPhotosButton: boolean = false;
  public lastLogsPhotos: LogEntryPhoto[];
  public dataLoading: DataLoading = { isLoading: false, message: '' };


  //---------------------- Services ---------------------------------------------//

  private _toastService: ToastService; // Service for toast notifications
 
  public _photoService: PhotoService; // Service for photo management
  private _screenSizeService: ScreenSizeService; // Service for managing screen size detection

  private _assetsDataService: AssetsDataService; // Service for asset data management

  constructor(
    assetsDataService: AssetsDataService,
    toastService: ToastService,
    screenSizeService: ScreenSizeService,
    photoService: PhotoService,
    private actionSheetController: ActionSheetController,
    private alertController: AlertController
  ) {
    this._toastService = toastService;
    this._assetsDataService = assetsDataService;
    this._screenSizeService = screenSizeService;
    this._photoService = photoService;

    const lastLogsPhotos = this._photoService.getLastLogEntryPhotos();
    this.lastLogsPhotos = lastLogsPhotos;

  }

  ngOnInit(): void {
    this.isMobile = this._screenSizeService.isMobile.getValue();
    this.photosSubscription = this._photoService.logEntryphotos$.subscribe((photos: LogEntryPhoto[]) => {
      this.photos = photos;
      this.showLastLogsPhotosButton = this.ShowLastLogsPhotosButton(photos, this.photosDisabled);
    });

    this.dataLoadingSubscription = this._photoService.dataLoading.subscribe((dataLoading: DataLoading) => {
      this.dataLoading = dataLoading;
    });
  }

  ngOnDestroy(): void {
    if (this.photosSubscription) {
      this.photosSubscription.unsubscribe();
    }
    if (this.dataLoadingSubscription) {
      this.dataLoadingSubscription.unsubscribe();
    }
  }

  ShowLastLogsPhotosButton(photos: LogEntryPhoto[], isDisablingPhotos: boolean): boolean {
    if (photos.length === 0 && this.lastLogsPhotos.length > 0 && !isDisablingPhotos) {
      return true;
    }
    return false;
  }

  useLastLogsPhotos() {
    const lastLogsPhotos = [...this._photoService.getLastLogEntryPhotos()];
    this._photoService.updateLogEntryPhotos(lastLogsPhotos);
  }

  deletePhoto(index: number) {
    if (this.photosDisabled) return;
    
    const photos = [...this.photos];
    photos.splice(index, 1);
    this._photoService.updateLogEntryPhotos(photos);
  }

  deleteAllPhotos(showWarningMessage: boolean = true) {
    if (showWarningMessage) {
      if (!confirm('Are you sure you want to delete all photos?')) {
        return;
      }
    }
    this._photoService.clearLogEntryPhotos();
  }

  copyPhotos() {
    copyPhotosToClipboard(this.photos, 'Photos copied to clipboard!', this.isMobile);
  }

  async togglePhotoInclusion(event: any): Promise<void> {
    const isDisablingPhotos = event.detail.checked;
    
    if (isDisablingPhotos) {
      let confirmMessage = "Are you sure you want to submit a log entry without photos?";
      
      if (this.photos.length > 0) {
        confirmMessage += "\nYou will lose your current photos if you disable photo inclusion.";
      }
      
      const alert = await this.alertController.create({
        header: 'Disable Photos',
        message: confirmMessage,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              const toggle = event.target;
              toggle.checked = !event.detail.checked;
              this.photosDisabled = !event.detail.checked;
            }
          },
          {
            text: 'Disable Photos',
            handler: () => {
              this.photosDisabled = true;
              if (this.photos.length > 0) {
                this.deleteAllPhotos(false);
              }
              this.photoInclusionChanged.emit(event.detail.checked);
            }
          }
        ]
      });
  
      await alert.present();
    } else {
      this.photosDisabled = false;
      this.photoInclusionChanged.emit(event.detail.checked);
      this.showLastLogsPhotosButton = this.ShowLastLogsPhotosButton(this.photos, false);
    }
  }

 
}



  

